import React, { Component } from 'react';
import axios from "axios";
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import _, { get } from 'lodash';
import { WithStyles, withStyles } from '@mui/styles';
import Cookies from 'js-cookie';

// Contexts
import { withTranslate, withTenant, withNavigation } from '../../core/TenantProvider';
import { getConfigProperty } from '../../core/EnvironmentConfig/EnvironmentConfig';
// Components - Atoms, Molecules, Organisms, Pages
import APFadeOverlayModal from './../../components/organisms/APFadeOverlayModal';
import APStepContainer from './../../components/organisms/APStepContainer';
import { DocumentsUploadContainer } from '../../components/organisms/DocumentsUploadContainer';
import { APRegistrationError } from '../../components/organisms/APRegistrationError';
import { APRegistrationSuccess } from "../../components/organisms/APRegistrationSuccess";
// Files in the same folder
import { REGISTRATION_FORM } from './definitions/registration';
import RegistrationContainerStyles from './styles/RegistrationContainer.style';
// Redux
import { actions as RegisterActions } from './../../redux/modules/register';
import { ReducerState } from './../../redux/modules';
import { actions as servicesDowntimeAction } from '../../redux/modules/servicesDowntime';
// Utils
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import GetBasicDetails from '../../core/utils/GetBasicDetails';
import GetDialingCode from '../../core/utils/GetDialingCode';

const {
  basicAuthToken: BASIC_AUTH_TOKEN,
  organisationCode: ORGANISATION
} = GetBasicDetails();

interface RegistrationContainerProps extends WithStyles<typeof RegistrationContainerStyles> {
  customer_state: any,
  loadingState: string,
  registerCustomer: Function,
  translate: Function,
  navigate: any,
  affiliateDetails: any,
  getServicesErrorObj: Function,
  settings: any,
  updateRegisterCustomerStatus: Function,
}

class RegistrationContainer extends Component<RegistrationContainerProps, {}> {
  state = {
    complete: false,
    showModal: false,
    doesCustomerAlreadyExists: false,
    customerAlreadyExistsCheckInProgress: false
  };

  static getDerivedStateFromProps(props: RegistrationContainerProps, state: any) {
    if (props.loadingState === "LOADED" || props.loadingState === 'UNINITIALISED') {
      return {
        ...state,
        showModal: false
      };
    }

    return state;
  }

  constructor(props: RegistrationContainerProps) {
    super(props);

    this.onClear = this.onClear.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  checkDuplicateEndPoint: string = getConfigProperty('apiEndPoint')['checkDuplicate'];
  accessToken = BASIC_AUTH_TOKEN;
  affiliateNumber: string | null = (sessionStorage.getItem('affiliate-number'));
  axiosDefaults: any = {
    "baseUrl": "",
    "headers": {
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Basic ${this.accessToken}`,
      "Content-Type": "application/json",
      "affiliate_number": this.affiliateNumber
    }
  };

  onClear() {
    this.setState({
      complete: false
    });
  }

  handleCustomerExistsError(error) {
    const {
      getServicesErrorObj
    } = this.props;
    if (error.response.status === 404) {
      this.setState({
        doesCustomerAlreadyExists: false,
        customerAlreadyExistsCheckInProgress: false
      });
    } else {
      this.setState({
        customerAlreadyExistsCheckInProgress: false
      });
    }
    getServicesErrorObj(error);
  }


  handleCustomerExistsResponse(response) {
    if (response.data['code'] === '2009') {
      this.setState({
        doesCustomerAlreadyExists: true,
        customerAlreadyExistsCheckInProgress: false
      });
    } else {
      this.setState({
        customerAlreadyExistsCheckInProgress: false
      });
    }
  }


  checkCustomerExists(name: any, form: any) {
    const endpoint = this.checkDuplicateEndPoint;
    const email = name === 'jointEmail' ? form.jointEmail : form.email;

    return axios.post(endpoint, {
      "email_address": email,
      "brand": ORGANISATION,
      "customer_type": 'pfx'
    });
  }

  checkValidInput(name: any, form: any, REGISTRATION_FORM_JSON: any) {
    const isEmailValid =
      (name === 'email' && form?.email?.length > 0 && Boolean(String(form.email).match(REGISTRATION_FORM_JSON[0]?.sections[1]?.fields[0]?.validation))) ||
      (name === 'jointEmail' && form?.jointEmail?.length > 0 && Boolean(String(form.jointEmail).match(REGISTRATION_FORM_JSON[0]?.sections[1]?.fields[0]?.validation)))

    return isEmailValid;
  }

  onChange(form: any, name: any) {
    const REGISTRATION_FORM_JSON: any = REGISTRATION_FORM;

    if (this.checkValidInput(name, form, REGISTRATION_FORM_JSON)) {
      this.setState({ customerAlreadyExistsCheckInProgress: true }, () => {
        axios.defaults.baseURL = this.axiosDefaults.baseURL;
        axios.defaults.headers.post = this.axiosDefaults.headers;

        this.checkCustomerExists(name, form).then((response) => {
          this.handleCustomerExistsResponse(response);
        }).catch((error) => {
          this.handleCustomerExistsError(error);
        });
      });
    }
  }

  onComplete(form: any) {
    const {
      registerCustomer,
      affiliateDetails
    } = this.props;

    this.setState({
      showModal: true
    });

    registerCustomer(form, affiliateDetails);

    TriggerGoogleAnalytics4Tag(
      GoogleAnalytics4Tags.registerClient.name,
      GoogleAnalytics4Tags.eventAction.load,
      GoogleAnalytics4Tags.registerClient.load.registrationLoaderPageLoad
    );
  }

  componentDidMount() {
    this.props.updateRegisterCustomerStatus();

    Cookies.remove('POI');
    Cookies.remove('POA');
    Cookies.remove('sellingCurrencyRegClient');
    Cookies.remove('buyingCurrencyRegClient');
    Cookies.remove('etv');
    Cookies.remove('register-client');
    TriggerGoogleAnalyticsTag(
      GoogleAnalyticTags.eventAction.load,
      GoogleAnalyticTags.registerClient.load.customerDetailsPageLoad
    );
    TriggerGoogleAnalytics4Tag(
      GoogleAnalytics4Tags.registerClient.name,
      GoogleAnalytics4Tags.eventAction.load,
      GoogleAnalytics4Tags.registerClient.load.customerDetailsPageLoad
    );
  }

  isErrorState = (loadingState, contacts, status) => {
    return (
      loadingState === 'POLLING_COMPLETE' ||
      loadingState === 'CUSTOMER_STATE_FAIL' ||
      loadingState === 'ERROR' ||
      (contacts && !status)
    );
  };

  shouldShowStepContainer = (complete, loaded, customer_state, isError) => {
    return !complete && !loaded && !customer_state?.contacts && !isError;
  }

  shouldShowDocumentsUpload = (complete, status, secondaryContactStatus, isError, singleAccDocuments, jointAccDocuments) => {
    return (
      !complete &&
      (status === 'INACTIVE' || secondaryContactStatus === 'INACTIVE' || status === 'ACTIVE') &&
      !isError &&
      ((singleAccDocuments?.length > 0) || (jointAccDocuments?.length > 0))
    );
  };

  shouldShowSuccessScreen = (complete, status, isError, singleAccDocuments) => {
    return !complete && status === 'ACTIVE' && (!singleAccDocuments || singleAccDocuments.length === 0) && !isError;
  };

  shouldShowErrorScreen = (complete, status, isError, singleAccDocuments) => {
    return !complete && ((status === 'INACTIVE' && (!singleAccDocuments || singleAccDocuments.length === 0)) || isError);
  };

  render() {
    const {
      classes,
      customer_state,
      loadingState,
      translate,
      affiliateDetails,
      getServicesErrorObj,
      settings
    } = this.props;

    const { complete, showModal, doesCustomerAlreadyExists, customerAlreadyExistsCheckInProgress } = this.state;

    const contacts = get(customer_state, 'contacts', []);
    const primaryContact = _.find(contacts, { primary_contact: true }) || {};
    const secondaryContact = _.find(contacts, { primary_contact: false }) || {};

    const { status = [{}] } = primaryContact;
    const secondaryContactStatus = secondaryContact.status;
    const singleAccDocuments = primaryContact.documents_required;
    const jointAccDocuments = contacts.length > 1 ? secondaryContact.documents_required : undefined;

    const loaded = loadingState === "LOADED";
    const isError = this.isErrorState(loadingState, contacts, !!status);
    const isJointAccReg = contacts.length > 1;
    const legalEntity = affiliateDetails?.affiliate?.legal_entity ?? '';

    return (
      <div className={classes.registrationContainerWrapper}>
        <div className={classes.registrationContainer}>

          {this.shouldShowStepContainer(complete, loaded, customer_state, isError) && (
            <APStepContainer
              defaults={{ mobile: { select: GetDialingCode(settings.ORG_CODE), input: '' } }}
              onComplete={this.onComplete}
              steps={REGISTRATION_FORM}
              title={translate('register.customer.title')}
              subTitle={translate('register.customer.subtitle')}
              onChange={this.onChange}
              doesCustomerAlreadyExists={doesCustomerAlreadyExists}
              customerAlreadyExistsCheckInProgress={customerAlreadyExistsCheckInProgress}
              legalEntity={legalEntity}
              getServicesErrorObj={getServicesErrorObj}
              formName="registerClient"
            />
          )}

          {!isError && (<APFadeOverlayModal open={showModal} pollingProgress={loaded ? 100 : 0} />)}

          {this.shouldShowDocumentsUpload(complete, status, secondaryContactStatus, isError, singleAccDocuments, jointAccDocuments) &&
            <DocumentsUploadContainer
              singleAccDocuments={singleAccDocuments}
              isJointAccReg={isJointAccReg}
              jointAccDocuments={jointAccDocuments}
              primaryContactStatus={status}
              secondaryContactStatus={secondaryContactStatus}
            />
          }

          {this.shouldShowSuccessScreen(complete, status, isError, singleAccDocuments) && (
            <APRegistrationSuccess />
          )}

          {this.shouldShowErrorScreen(complete, status, isError, singleAccDocuments) && (
            <APRegistrationError />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store: ReducerState) => ({
  customer_state: store.register.customer_state,
  loadingState: store.register.loadingState,
  affiliateDetails: store.user.affiliateDetails
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  registerCustomer: RegisterActions.registerCustomer,
  getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj,
  updateRegisterCustomerStatus: RegisterActions.updateRegisterCustomerStatus
}, dispatch);

export default withNavigation(
  withTenant(
    withTranslate(
      withStyles(RegistrationContainerStyles)(
        connect(mapStateToProps, mapDispatchToProps)(RegistrationContainer)
      )
    )
  )
);